import { Model } from "@tailflow/laravel-orion/lib/model";

export class ProductColor extends Model<{
  title: string;
}> {
  public $resource(): string {
    return "product_colors";
  }
}
